import React from 'react';
import './MarkAsResolvedModal.css';

export const MarkAsResolvedModal = ({isOpen, onClose, onConfirm}) =>
{
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content mark-resolved-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2 className="modal-title">Mark as Resolved</h2>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>

        <div className="modal-body">
          <p className="mark-resolved-message">
            Are you sure you want to mark this item as resolved?
          </p>
        </div>

        <div className="modal-footer">
          <button className="btn-cancel" onClick={onClose}>
            Cancel
          </button>
          <button className="btn-confirm" onClick={onConfirm}>
            Mark as Resolved
          </button>
        </div>
      </div>
    </div>
  );
};
